import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { PronosticoMeteorologicoState } from './types'

export const getters: GetterTree<PronosticoMeteorologicoState, RootState> = {
  getPronosticoMeteorologico (state: PronosticoMeteorologicoState) {
    return state
  }
}
